import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnitDetailsRoutingModule } from './unit-details-routing.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

import { UnitDetailsComponent } from './unit-details/unit-details.component';
import { UnitDetailsHeaderComponent } from './unit-details-header/unit-details-header.component';
import { UnitDetailsInfoComponent } from './unit-details-info/unit-details-info.component';
import { UnitDetailsCalendarComponent } from './unit-details-calendar/unit-details-calendar.component';
import { UnitDetailsHeaderTitleComponent } from './unit-details-header-title/unit-details-header-title.component';
import { UnitDetailsHeaderControlsComponent } from './unit-details-header-controls/unit-details-header-controls.component';
import { UnitDetailsHeaderControlsMonthComponent } from './unit-details-header-controls-month/unit-details-header-controls-month.component';
import { UnitDetailsHeaderControlsYearComponent } from './unit-details-header-controls-year/unit-details-header-controls-year.component';
import { UnitDetailsCalendarCellComponent } from './unit-details-calendar-cell/unit-details-calendar-cell.component';

@NgModule({
  declarations: [
    UnitDetailsComponent,
    UnitDetailsHeaderComponent,
    UnitDetailsInfoComponent,
    UnitDetailsCalendarComponent,
    UnitDetailsHeaderTitleComponent,
    UnitDetailsHeaderControlsComponent,
    UnitDetailsHeaderControlsMonthComponent,
    UnitDetailsHeaderControlsYearComponent,
    UnitDetailsCalendarCellComponent,
  ],
  imports: [
    CommonModule,
    UnitDetailsRoutingModule,
    ToolbarModule,
    SharedModule,
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
  ],
})
export class UnitDetailsModule {}
